import { FreeMode, Mousewheel, Navigation, Pagination, Scrollbar } from 'swiper';

import { Slider } from './slider';

class ScrollSlider extends Slider {
  init() {
    super.init();
  }
}

export const scrollSlider = () => {
  const containers = document.querySelectorAll('.js-slider-scroll');
  containers.forEach((container) => {
    const parameters = {
      modules: [FreeMode, Mousewheel, Navigation, Pagination, Scrollbar],
      slidesPerView: 'auto',
      speed: 400,
      spaceBetween: 12,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: container.querySelector('.swiper-pagination'),
        clickable: true,
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        dragClass: 'c-scrollBar__drag',
        draggable: true,
      },
      freeMode: {
        enabled: true,
      },
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        768: {
          spaceBetween: 16,
        },
      },
    };

    const scrollSliderInstance = new ScrollSlider(container, parameters);

    scrollSliderInstance.init();
  });
};
